/** Resolve storage inside the guard: the browser property itself can throw. */
export function readOptionalBrowserValue(resolveStorage: () => Pick<Storage, 'getItem'>, key: string): string {
  try { return resolveStorage().getItem(key) || ''; } catch { return ''; }
}

export function writeOptionalBrowserValue(resolveStorage: () => Pick<Storage, 'setItem'>, key: string, value: string): void {
  try { resolveStorage().setItem(key, value); } catch { /* The current in-memory form remains usable. */ }
}
